/**
 * Created by Marcus Zhao on 12/01/2020
 * -------------------------------------
 */

import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../redux';
import { IntlService } from '@progress/kendo-angular-intl';
import { ContactTemplateService } from '../../../contact-dialog-new/contact-template.service';
import { ContactTemplateControlValue } from '@tamalelibs/models/contact-template-control-value.model';
import { ChangeContactTemplateValueSet } from '@tamalelibs/redux/contact.actions';
import { ContactTemplateType } from '../../../contact-dialog-new/contact-dialog.model';
import { Subscription } from 'rxjs';
import { businessConstants } from '../../../../constants/business.constants';

@Component({
    selector: 'tam-contact-date',
    templateUrl: './contact-date.component.html',
    styleUrls: ['./contact-date.component.scss'],
    standalone: false
})
export class ContactDateComponent implements OnInit, OnDestroy {
    @Input() childConfig: any;
    config: any;
    value: Date;
    readOnly = false;
    hintContent = '';
    min: Date = new Date(1900, 1, 1);
    max: Date = new Date();
    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _store: Store<AppState>,
        private _intl: IntlService,
        private _contactTemplateService: ContactTemplateService,
    ) { }

    ngOnInit() {
        this.config = this.childConfig.config;
        if (this.config.action === ContactTemplateType.EditContact) {
            this._initEditValue();
        }
        this._destroySubscriptions.push(
            this._contactTemplateService.validInputSubject$.subscribe((res) => {
                if (this.config.prefixId === res.prefixId && !this.value && this.config.isRequired) {
                    this.hintContent = businessConstants.tip;
                }
            }));
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    /**
     * date change
     * @param {*} value
     * @memberof ContactDateComponent
     */
    textOnChange(value) {
        this.hintContent = '';
        this._contactTemplateService.changeValueStatus = true;
        this._changeValueSet();
    }

    /**
     * init edit value
     * @private
     * @memberof ContactInputComponent
     */
    private _initEditValue() {
        this.value = this.config.editValue;
        this._changeValueSet();
    }

    /**
     * set value to store
     * @memberof ContactDateComponent
     */
    _changeValueSet() {
        let displayValue;
        if (this.value) {
            displayValue = this._intl.formatDate(this.value, 'yyyy/MM/dd').toString();
        }
        const value = new ContactTemplateControlValue(this.value, displayValue, this.config);
        this._store.dispatch(
            new ChangeContactTemplateValueSet(
                value,
                'prefix',
                this.config.prefixId
            )
        );
    }
}
